import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA39AhWa3rD_HttmTpi3-hzoWZcpAfzC48",
  authDomain: "yoamobazurto-f86de.firebaseapp.com",
  projectId: "yoamobazurto-f86de",
  storageBucket: "yoamobazurto-f86de.firebasestorage.app",
  messagingSenderId: "786109353597",
  appId: "1:786109353597:web:47245a01b064f85c84ab14",
  measurementId: "G-LSNSC2J0DR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };
